module.exports = __webpack_public_path__ + "media/application/images/svgs/social_linkedin-5c0995d8a5cea729d7b6d18cc55f2922.svg";